export default __webpack_public_path__ + "static/media/theme-pink.a39a8692.png";